<template>
  <div class="list__container">
    <div class="prev" @click="prevSlide">
      <img :src="mediaBaseUrl + prevReview.image" alt="" class="image">
      <img :src="mediaBaseUrl + 'landing/reviews/arrow-left.svg'" alt="" class="arrow">
      <div class="bg"></div>
    </div>

    <div class="review">
      <div class="img">
        <img :src="mediaBaseUrl + activeReview.image" alt="">
      </div>

      <div class="review__wrapper">
        <img :src="mediaBaseUrl + 'landing/reviews/quote.svg'" alt="">

        <div class="review__content">
          <p>{{activeReview.text}}</p>
        </div>

        <div class="review__author">
          <div class="author__content">
            <div class="author__name">{{activeReview.author}}</div>
            <div class="review__date">{{activeReview.date}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="next" @click="nextSlide">
      <img :src="mediaBaseUrl + nextReview.image" alt="" class="image">
      <img :src="mediaBaseUrl + 'landing/reviews/arrow-right.svg'" alt="" class="arrow">
      <div class="bg"></div>
    </div>

    <div class="controllers">
      <div class="img" @click="prevSlide">
        <img :src="mediaBaseUrl + 'landing/reviews/arrow-left1.svg'" alt="arrow left">
      </div>
      <div class="img" @click="nextSlide">
        <img :src="mediaBaseUrl + 'landing/reviews/arrow-right1.svg'" alt="arrow right">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewsList",
  inject: ["mediaBaseUrl"],

  data() {
    return {
      slidesToShow: 1,
      activeSlide: 0,
      reviews: this.$t('landing.reviews.list'),
      sliderWidth: 505,
      sliderGap: 24,
    };
  },

  created() {
    // this.timer = setInterval(() => this.nextSlide(), 10000);
    // window.addEventListener("resize", this.isMobile);
    // this.isMobile();
  },

  beforeDestroy() {
    clearInterval(this.timer);
    // window.removeEventListener("resize", this.isMobile);
  },

  computed: {
    sliderLeft() {
      const slide = document.getElementsByClassName("review")[0];
      let slideWidth = this.sliderWidth;

      if (slide) {
        slideWidth = +getComputedStyle(slide).width.slice(0,3);
      }

      return -(this.activeSlide * (slideWidth + this.sliderGap));
    },
    activeReview() {
      return this.reviews[this.activeSlide];
    },
    nextReview() {
      if (this.activeSlide === this.reviews.length - 1) {
        return this.reviews[0];
      } else {
        return this.reviews[this.activeSlide + 1];
      }
    },
    prevReview() {
      if (this.activeSlide === 0) {
        return this.reviews[this.reviews.length - 1];
      } else {
        return this.reviews[this.activeSlide - 1];
      }
    },
  },

  methods: {
    isMobile() {
      if (window.innerWidth > 700) {
        this.slidesToShow = 1;
      } else {
        this.slidesToShow = 1;
      }
    },
    nextSlide() {
      // this.resetTimer();
      if (this.activeSlide + this.slidesToShow >= this.reviews.length) {
        this.activeSlide = 0;
      } else {
        this.activeSlide++;
      }
    },
    prevSlide() {
      // this.resetTimer();
      if (this.activeSlide - 1 < 0) {
        this.activeSlide = this.reviews.length - this.slidesToShow;
      } else {
        this.activeSlide--;
      }
    },
    resetTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => this.nextSlide(), 10000);
    },
  },
}
</script>

<style lang="sass">
@import '../../../sass/variables'

$width: 100%
$height: fit-content
$gap: 24px
$padding: 0
$radius: 8px

$lg: 1040px

.list__container
  display: flex
  position: relative
  flex-direction: column
  align-items: flex-start
  width: 100%

  @media screen and (min-width: $lg)
    flex-direction: row
    align-items: stretch
    gap: 24px

  .next,
  .prev
    display: none
    align-items: center
    justify-content: center
    position: relative
    width: 233px
    height: 401px
    border-radius: 8px
    overflow: hidden
    cursor: pointer
    z-index: 1

    .bg
      background: rgba(46, 155, 138, 0.8)
      width: 100%
      height: 100%
      position: absolute
      left: 0
      top: 0
      z-index: 0

    .image
      position: absolute
      top: 0
      left: 50%
      transform: translateX(-50%)
      transition: .5s
      z-index: -1

    .arrow
      z-index: 1

    &:hover
      .image
        transform: translateX(-50%) scale(1.1)

    @media screen and (min-width: $lg)
      display: flex

  .slides
    display: flex
    justify-content: center
    gap: 0px
    margin: 0 16px
    width: fit-content
    background: rgba(213, 213, 213, 1)
    border-radius: 40px

    .slide
      background: rgba(213, 213, 213, 1)
      min-width: 23px
      border-radius: 40px
      cursor: pointer
      transition: .3s ease
      height: 4px

      &.slide_active
        background: rgba(192, 60, 80, 1)

      @media screen and (min-width: $lg)
        min-width: 69px

  .controllers
    display: flex
    justify-content: center
    align-items: center
    gap: 16px
    margin-top: 24px
    width: 100%

    .img
      display: flex
      align-items: center
      justify-content: center
      min-width: 64px
      height: 64px

    @media screen and (min-width: $lg)
      display: none

    .img
      cursor: pointer
      transition: .3s ease

      &:hover
        opacity: .8

      &.controller_disabled
        pointer-events: none
        opacity: .3

  .reviews__content
    display: flex
    flex-direction: column
    justify-content: space-between
    position: relative
    //overflow: hidden
    width: 100%
    flex-grow: 1

    .reviews__list
      display: flex
      position: absolute
      flex-direction: row
      gap: $gap
      left: 0
      top: 0
      transition: left .5s ease

  .review__stars
    display: flex
    justify-content: flex-start
    align-items: center
    gap: 0px

  .review
    display: flex
    flex-direction: column
    align-items: flex-start
    position: relative
    width: $width
    min-height: $height
    padding: $padding
    border-radius: $radius
    transition: .3s ease
    z-index: 1
    max-width: 1000px

    .img
      position: relative
      height: 250px
      width: 100%
      overflow: hidden
      border-radius: 8px
      margin-bottom: -8px
      z-index: -1

      img
        border-radius: 8px
        position: absolute
        top: 0
        left: 50%
        transform: translateX(-50%)

    @media screen and (min-width: $lg)
      flex-direction: row
      align-items: stretch

      .img
        height: 401px
        max-width: 340px
        width: 100%
        margin-bottom: 0

    .review__wrapper
      display: flex
      width: 100%
      flex-direction: column
      align-items: flex-start
      border-radius: 8px
      padding: 8px 18px 27px 23px
      background: rgba(255, 255, 255, 1)

    p
      position: relative
      font-size: 18px
      line-height: 27px
      font-weight: 400
      text-align: left
      //flex-grow: 1
      color: rgba(7, 24, 45, 1)
      z-index: 1

      @media screen and (min-width: $lg)
        font-size: 20px
        line-height: 30px

    .review__content
      display: flex
      flex-direction: column
      position: relative
      margin-bottom: 40px
      gap: 8px

    .review__author
      display: flex
      flex-direction: row
      justify-content: flex-start
      align-items: center
      width: 100%

    .author__content
      display: flex
      flex-direction: column
      align-items: flex-start
      justify-content: flex-start
      width: 100%

    .author__name
      font-size: 18px
      line-height: 27px
      font-weight: 700
      text-align: left
      color: rgba(7, 24, 45, 1)
      margin-bottom: 6px

    .review__date
      font-size: 1rem
      line-height: 1.5rem
      font-weight: 400
      text-align: left
      color: rgba(76, 96, 122, 1)
</style>
